import { Month } from "./Month.js";
import { validateMonth } from "./validateMonth.js";

/**
 * Returns the current month.
 */
export const getCurrentMonth = (): Month => {
  return validateMonth((new Date().getUTCMonth() + 1).toString().padStart(2, "0"));
};
